module.exports = __webpack_public_path__ + "img/oper-icon2.ea6d2de2.png";